/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Topic Opt Out Schema
 * @export
 * @interface TopicOptOut
 */
export interface TopicOptOut {
    /**
     * Message Channel
     * @type {string}
     * @memberof TopicOptOut
     */
    channel: TopicOptOutChannelEnum;
    /**
     * Message Endpoint
     * @type {string}
     * @memberof TopicOptOut
     */
    endpoint: string;
    /**
     * Message Topic
     * @type {string}
     * @memberof TopicOptOut
     */
    topic: string;
    /**
     * Opt Out Created Date
     * @type {Date}
     * @memberof TopicOptOut
     */
    createdDate: Date;
}


/**
 * @export
 */
export const TopicOptOutChannelEnum = {
    Sms: 'sms',
    Email: 'email'
} as const;
export type TopicOptOutChannelEnum = typeof TopicOptOutChannelEnum[keyof typeof TopicOptOutChannelEnum];


/**
 * Check if a given object implements the TopicOptOut interface.
 */
export function instanceOfTopicOptOut(value: object): value is TopicOptOut {
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    if (!('topic' in value) || value['topic'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    return true;
}

export function TopicOptOutFromJSON(json: any): TopicOptOut {
    return TopicOptOutFromJSONTyped(json, false);
}

export function TopicOptOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopicOptOut {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': json['channel'],
        'endpoint': json['endpoint'],
        'topic': json['topic'],
        'createdDate': (new Date(json['created_date'])),
    };
}

export function TopicOptOutToJSON(value?: TopicOptOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channel': value['channel'],
        'endpoint': value['endpoint'],
        'topic': value['topic'],
        'created_date': ((value['createdDate']).toISOString()),
    };
}

